import localRegions from "@data/localRegions.json";
import {NextPageContext} from "next/types";
import React from "react";
import {ignoreArrays} from "src/utils/ignoreArrays";

import ClinicDetails from "./clinic-details";
import LocationsIndex from ".";
import {RegionSlug} from "../../store/types";
import {useRouter} from "next/router";

const allRegionSlugs: (string | null)[] = localRegions.map(r => r.slug);

type Props =
  | {
      regionSlug: RegionSlug;
    }
  | React.ComponentProps<typeof ClinicDetails>;

const LocationsRouter = (props: Props) => {
  const router = useRouter();
  if ("regionSlug" in props) {
    // because of shallow, regionSlug is not updated on region change on client,
    // we need to use router.query.slug
    const regionFromQuery = ignoreArrays(router.query.slug) as RegionSlug;
    return <LocationsIndex regionSlug={regionFromQuery || props.regionSlug} />;
  }

  return <ClinicDetails {...props} />;
};

LocationsRouter.getInitialProps = async (context: NextPageContext) => {
  const slug = ignoreArrays(context.query.slug);
  if (allRegionSlugs.includes(slug)) {
    return {regionSlug: slug};
  }

  return ClinicDetails.getInitialProps?.(context);
};

export default LocationsRouter;
